import { useEffect, useState } from 'react';
import { Logo, ThemeToggle, cn } from '@mgp/ui';
import { ADVERTISER_LOGIN_URL, ADVERTISER_REGISTER_URL } from '../lib/links';
import { ctaClass } from '../lib/cta';

const SECTION_LINKS = [
  { label: 'What we do', href: '#services' },
  { label: 'How it works', href: '#how' },
  { label: 'FAQ', href: '#faq' },
];

export function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={cn(
        'sticky top-0 z-30 w-full transition-[background-color,border-color,backdrop-filter] duration-base',
        scrolled
          ? 'border-b border-border-soft bg-surface/80 backdrop-blur'
          : 'border-b border-transparent bg-transparent',
      )}
    >
      <div className="mx-auto flex h-16 max-w-container-lg items-center gap-7 px-4 sm:px-6 lg:px-8">
        <a href="/" className="flex shrink-0 items-center gap-2.5" aria-label="Adspert home">
          <Logo className="h-10 w-10" />
        </a>

        <nav className="hidden flex-1 md:block">
          <ul className="flex items-center gap-7 text-base text-ink-secondary">
            {SECTION_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="transition-colors duration-fast hover:text-ink">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="ml-auto flex items-center gap-3">
          <ThemeToggle />
          <a
            href={ADVERTISER_LOGIN_URL}
            className="hidden text-base text-ink-secondary transition-colors duration-fast hover:text-ink sm:inline-flex"
          >
            Sign in
          </a>
          <a href={ADVERTISER_REGISTER_URL} className={ctaClass('primary', 'md')}>
            Start advertising
          </a>
        </div>
      </div>
    </header>
  );
}
